import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { NAV_GROUPS } from "./nav";
import { useApp } from "../../context/AppContext";
import { LOGO_URL } from "../../lib/brand";

export default function Sidebar({ onNavigate }) {
  const { t } = useApp();
  const location = useLocation();

  return (
    <div className="flex flex-col h-full bg-gradient-to-b from-[#f7ecd6] via-[#f4efe2] to-[#eef2e5]" data-testid="sidebar">
      {/* brand */}
      <div className="h-[72px] flex items-center gap-3 px-5 shrink-0">
        <img src={LOGO_URL} alt="Agro Madat" className="h-11 w-11 rounded-2xl object-contain bg-white shadow-sm" />
        <div className="leading-tight">
          <p className="font-display font-extrabold text-[16px] text-[#173f1e]">Agro <span className="text-[#2f7d33]">Madat</span></p>
          <p className="text-[10px] text-[#6c7a67]">आपका स्मार्ट खेती साथी</p>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-3 space-y-4">
        {NAV_GROUPS.map((group) => (
          <div key={group.label}>
            <p className="px-3 mb-1.5 text-[10px] font-bold uppercase tracking-wider text-[#6c7a67]/80">
              <span className="inline-block pb-0.5 border-b border-[#f2c230]/60">{t(group.label)}</span>
            </p>
            <div className="space-y-1">
              {group.items.map((item) => {
                const active = location.pathname === item.to;
                const Icon = item.icon;
                return (
                  <NavLink key={item.key} to={item.to} onClick={onNavigate} data-testid={`nav-${item.key}`}
                    className="block group">
                    <motion.div whileTap={{ scale: 0.98 }}
                      className={`flex items-center gap-3 pl-2 pr-3 py-2 rounded-2xl text-sm font-semibold transition-colors ${
                        active ? "bg-[#2f7d33] text-white shadow-[0_6px_18px_rgba(47,125,51,0.35)]" : "text-[#1c2b1e]/80 hover:bg-white/60"
                      }`}>
                      <span className={`h-9 w-9 rounded-xl flex items-center justify-center shrink-0 ${active ? "bg-white/20" : "bg-white/70 border border-white/70 shadow-sm"}`}>
                        <Icon className={`h-[18px] w-[18px] ${active ? "text-white" : "text-[#2f7d33]"}`} />
                      </span>
                      <span className={`truncate rounded px-1 -mx-1 transition-colors ${active ? "" : "group-hover:bg-[#f2c230]/25"}`}>{t(item.key)}</span>
                    </motion.div>
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
}
